import classNames from 'clsx';
import React, { memo, ReactElement, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { sendDwh } from 'reactApp/utils/ga';
import { noop } from 'reactApp/utils/helpers';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import styles from './ActionsBar.css';
import { useItems } from './useItems';

export enum EActionsMode {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}

export const ActionsBar = memo(({ mode }: { mode?: EActionsMode }): ReactElement => {
    const selectedIds = useSelector(SelectionsSelectors.getSelectedIdxs);
    const items = useItems();

    const sendAnalytics = useCallback(({ action, source, ...data }) => {
        sendDwh({
            eventCategory: ECategoryGa.toolbar,
            action,
            dwhData: {
                ...data,
                source: `touch-${source}`,
            },
        });
    }, []);

    return (
        <div className={classNames(styles.root, styles[`root_${mode}`])}>
            <div className={styles.counter}>{selectedIds.length}</div>
            <div className={styles.bar}>
                {items.map((item) => (
                    <div
                        key={item.id}
                        onClick={item.disabled ? noop : () => item.onClick(null, sendAnalytics)}
                        className={classNames({
                            [styles.barItem]: true,
                            [styles[`barItem_${item.id}`]]: Boolean(item.id),
                            [styles.barItem_disabled]: item.disabled,
                        })}
                        data-qa-action={item.id}
                    >
                        {item.icon}
                        {item.text}
                    </div>
                ))}
            </div>
        </div>
    );
});

ActionsBar.displayName = 'ActionsBar';
